const calculateBoundingBox = (landmarks, videoWidth, videoHeight) => {
  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;

  for (const point of landmarks) {
    minX = Math.min(minX, point.x);
    minY = Math.min(minY, point.y);
    maxX = Math.max(maxX, point.x);
    maxY = Math.max(maxY, point.y);
  }

  return {
    xMin: minX * videoWidth,
    yMin: minY * videoHeight,
    width: (maxX - minX) * videoWidth,
    height: (maxY - minY) * videoHeight,
  };
};

export default calculateBoundingBox;
